// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__KmnZC","header":"PatientQuestionnaire_header__10u1F","info":"PatientQuestionnaire_info__2pbjO"};